import React from "react";
import PropTypes from "prop-types";

const Checkbox = ({
  id,
  label,
  checked,
  onChange,
  className = "",
  variant,
  ref,
  name,
  value,
  disabled,
  formatechild,
  customLabel = true,
  children,
  labelClass = "",
  secondLabel,
  secondaryLabel,
  labelOnClick,
}) => {
  const formate = !!formatechild;

  return (
    <div className={`filterCheckbox ${disabled ? "disabled" : ""} ${className}`}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange} // Ensure this handler is always provided
        ref={ref}
        name={name}
        value={value} // Use value instead of defaultValue for controlled components
        disabled={disabled}
        className="checkbox-input"
        aria-checked={checked} // Accessibility: Indicates the current state
        aria-disabled={disabled} // Accessibility: Indicates if the checkbox is disabled
      />
      {children}
      {customLabel && (
        <label
          htmlFor={id}
          className={`checkbox-label ${labelClass}`}
          onClick={labelOnClick}
        >
          {label}
          {formate && <span>&nbsp;({formatechild})</span>}
          {secondaryLabel && <span>{secondLabel}</span>}
        </label>
      )}
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired, // id is required to associate the label with the input
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired, // Ensure this is always provided
  className: PropTypes.string,
  variant: PropTypes.string,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  name: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  formatechild: PropTypes.node,
  customLabel: PropTypes.bool,
  children: PropTypes.node,
  labelClass: PropTypes.string,
  secondLabel: PropTypes.string,
  secondaryLabel: PropTypes.bool,
  labelOnClick: PropTypes.func,
};

Checkbox.defaultProps = {
  label: "",
  checked: false,
  className: "",
  disabled: false,
  customLabel: true,
  formatechild: null,
  secondLabel: "",
  secondaryLabel: false,
  labelOnClick: null,
};

export default Checkbox;
